import { render, staticRenderFns } from "./PersonnelComponent.vue?vue&type=template&id=367172de&scoped=true&"
import script from "./PersonnelComponent.vue?vue&type=script&lang=js&"
export * from "./PersonnelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367172de",
  null
  
)

export default component.exports